<button class="btn restore_i_btn">
    <i class="material-icons pointer" title="{{ 'CONSTANTS.RESET_2FA' | translate }}">settings_backup_restore</i>
</button>